import React from 'react';

const Iframe = ({ src, title, width, height }) => {
  return (
      <iframe
      className='text-white bg-white'
        src={src}
        title={title}
        width={width}
        height={height}
        frameBorder="0"
        allowFullScreen
      ></iframe>
  );
};

export default Iframe;